const Icons = {
  logo: require('../assets/images/tp_logo.png'),
  Menu: require('../assets/images/Menu.png'),
  Are: require('../assets/Icons/Are.png'),
  car: require('../assets/Icons/car.png'),
  hotel: require('../assets/Icons/hotel.png'),
  travel: require('../assets/Icons/travel1.png'),
  visa: require('../assets/Icons/visa.png'),
  BsWhatsapp: require('../assets/Icons/BsWhatsapp.png'),
  travel1: require('../assets/Icons/travel.png'),
  travel2: require('../assets/Icons/travel2.png'),
  travel3: require('../assets/Icons/travel3.png'),
  travel4: require('../assets/Icons/travel4.png'),
  // Users: require('../assets/Icons/Users.jpg'),
  // Users1: require('../assets/Icons/Users1.jpg'),
  flyingPlan: require('../assets/images/flying-plan.png'),
  planeBug: require('../assets/images/plane-bug.png'),
  AboutUs: require('../assets/images/AboutUs.jpg'),
  flying_plan_only: require('../assets/Icons/flying-plan-only.png'),
  flying_plan_only1: require('../assets/Icons/flying_plan_only1.png')
}
export default Icons
